import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Link from 'gatsby-link';

const FrontPageAbout = props => {
  const { image } = props;

  return (
    <section className="front-page--section">
      <h1 className="front-page--title front-page--title-divider">About</h1>
      <div className="columns">
        <div className="column">
          <Img alt="Profile image of Jody Boucher" sizes={image.sizes} />
        </div>
        <div className="column">
          <p>
            Hello, my name is <Link to="/">Jody Boucher</Link>.
          </p>
          <p>I am a freelance software developer with over a decade of experience.</p>
          <p>
            I am passionate about technology and crafting simple solutions to complex challenges.
          </p>
          <p>I believe in writing code that is clean, clear and deliberate.</p>
        </div>
      </div>
    </section>
  );
};

FrontPageAbout.propTypes = {
  image: PropTypes.shape({
    sizes: PropTypes.object,
  }).isRequired,
};

export default FrontPageAbout;



// WEBPACK FOOTER //
// ./src/components/FrontPageAbout.js